module.exports = __webpack_public_path__ + "media/images/es_419/performance-index-continuum-full-5412550339104cddf78173698712d97d.jpg";